import { render, staticRenderFns } from "./SDialogSearchProductComp.vue?vue&type=template&id=7a8752a4&"
import script from "./SDialogSearchProductComp.vue?vue&type=script&lang=js&"
export * from "./SDialogSearchProductComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports